






























































import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { UpdateChapterItemPayload } from '@/app/shared/store/modules/reports.store-module';
import PresentationsAssessingTableImpact from '@/app/presentations/components/tables/PresentationsAssessingTableImpact.vue';
import ImpactTable from '@/app/shared/components/ImpactTable.vue';
import { GRAPHIK_FONT_FAMILY_FOR_HTML_STYLE } from '@/app/shared/store/modules/presentations.constants';
import { ChapterItem } from '@/app/shared/models/reports/ChapterItem';
import { ChapterItemType } from '@/app/shared/enums/chapter-item-type.enum';
import api from '@/app/shared/api';

const ReportsStore = namespace('Reports');

@Component({
  components: {
    PresentationsAssessingTableImpact,
    ImpactTable,
  },
})
export default class SingleImpactSignificanceTable extends Vue {
  @Prop() item: ChapterItem;

  tableData: any = [];
  tableTitle: string = null;
  titleInEditMode: boolean = false;
  viewMode: 'list' | 'comments' | 'details' | 'details_and_comments' = 'details';
  sizeMode: 'full' | 'half' = 'full';

  ChapterItemType: ChapterItemType;

  style = {
    titleWrapper: {
      display: 'flex',
      marginBottom: '38px',
    },
    tableTitleNumeration: {
      height: '32px',
      fontSize: '24px',
      lineHeight: '32px',
      display: 'flex',
      alignItems: 'center',
    },
    numeration: {
      marginRight: '0.75rem',
      position: 'relative',
      fontWeight: '500',
    },
    tableTitle: {
      flex: 1,
      position: 'relative',
      textAlign: 'left',
    },
    tableTitleSpan: { fontWeight: '500', color: '#222c37' },
    tableWrapper: {
      // marginTop: '38px',
      color: '#222C37',
    },
    topBorder: {
      borderRadius: '2px 2px 0 0',
      height: '8px',
      background: '#D3DADC',
    },
    tableHeader: {
      height: '64px',
      width: '100%',
      borderBottom: '6px solid #a3aeba',
      boxSizing: 'content-box',
      display: 'flex',
    },
    evaluationMethod: {
      flex: '1',
      background: '#a3aeba',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      padding: '0 16px',
      minWidth: 0,
    },
    evaluationMethodLabel: {
      color: '#E5EAEC',
      textTransform: 'uppercase',
      fontSize: '10px',
      lineHeight: '16px',
      letterSpacing: '0.15px',
      fontWeight: 500,
    },
    evaluationMethodValue: {
      color: 'white',
      fontSize: '14px',
      lineHeight: '16px',
      letterSpacing: '0.22px',
      fontWeight: 500,
      textAlign: 'left',
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: '100%',
    },
    criteriaGroupsWrapper: {
      display: 'flex',
    },
    criteriaGroup: {
      display: 'flex',
      flexDirection: 'column',
      height: '64px',
    },
    criteriaLabel: {
      height: '40%',
      borderBottom: '1px solid #d3dadc',
      borderRight: '1px solid #d3dadc',
      color: '#6F8195',
      fontSize: '12px',
      lineHeight: '12px',
      letterSpacing: '-0.2px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f8fafa',
    },
    criteriaList: {
      height: '60%',
      display: 'flex',
    },
    criteriaLabelOnly: {
      height: '100%',
      with: '100%',
      borderBottom: '1px solid #d3dadc',
      borderRight: '1px solid #d3dadc',
      color: '#6F8195',
      fontSize: '12px',
      lineHeight: '12px',
      letterSpacing: '-0.2px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#f8fafa',
      padding: '0.5em',
    },
    criteria: {
      height: '100%',
      width: '80px',
      borderRight: '1px solid #d3dadc',
      color: '#6F8195',
      fontSize: '11px',
      lineHeight: '12px',
      letterSpacing: '-0.2px',
      fontWeight: 500,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      boxSizing: 'border-box',
      padding: '0.3em',
    },
    significanceCol: {
      flexBasis: '40px',
      background: '#a3aeba',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    significanceColSpan: {
      color: '#E5EAEC',
      textTransform: 'uppercase',
      fontSize: '10px',
      lineHeight: '10px',
      letterSpacing: '0px',
      fontWeight: 500,
    },
    table: { border: '1px solid #D3DADC' },
  };

  @ReportsStore.Action
  public updateChapterItem!: (payload: UpdateChapterItemPayload) => Promise<any>;

  @ReportsStore.Action
  public lockChapterItem!: (uuid: string) => Promise<any>;

  @ReportsStore.Action
  public unlockChapterItem!: (uuid: string) => Promise<any>;

  get methodName() {
    return this.tableData[0]?.method_approach;
  }

  get criteriaList() {
    return this.tableData[0]?.method.unit.checktrees[0].children.filter((el: { checked: boolean }) => el.checked);
  }

  async initializeTableData(payload: any) {
    this.tableData = await api.reports.getImpactAssessmentTableData(
      payload.uuid,
      payload.fromMatrix,
      payload.tableType,
      payload.cumulative,
    );
  }

  created() {
    let payload: any = null;
    if (this.item.payload) {
      payload = this.item.payload;
    } else {
      payload = {
        uuid: this.$route.params.uuid,
        fromMatrix: this.$route.query.fromMatrix as string,
        tableType: this.item.table_type,
        cumulative: this.$route.query.cumulative === 'true',
      };
    }

    this.initializeTableData(payload).then(() => {
      this.updateTableHTML(payload);
    });
  }

  async updateTableHTML(payload: any) {
    try {
      const html = `
        <!DOCTYPE html>
        <html>
          <head>
            <style>
              ${GRAPHIK_FONT_FAMILY_FOR_HTML_STYLE}
              * {
                font-family: 'Graphik', Avenir, Helvetica, Arial, sans-serif;
              }
            </style>
          </head>
          <body>
            ${(this.$refs.assessingTable as HTMLElement).innerHTML}
          </body>
        </html>
        `;

      const additionalProperties = [
        {
          name: 'payload',
          value: JSON.stringify(payload),
        },
      ];

      if (this.item.html != html) {
        await this.lockChapterItem(this.item.uuid);
        await this.updateChapterItem({
          uuid: this.item.uuid,
          type: ChapterItemType.IMPACT_TABLE,
          propertyName: 'html',
          propertyValue: html,
          additionalProperties,
        });
        await this.unlockChapterItem(this.item.uuid);
      }
    } catch (error) {
      console.error(error);
    }
  }
}
